export const getSHA1HashOfString = async (str: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hash = await window.crypto.subtle.digest('SHA-1', data);
  const result = buf2hex(hash);
  return result;
  //return crypto.createHash('sha1').update(str.toLowerCase()).digest('hex');
};

function buf2hex(buffer: ArrayBuffer) {
  return [...new Uint8Array(buffer)].map((x) => x.toString(16).padStart(2, '0')).join('');
}
